import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import {
  generateLgpdTerm,
  generateTermsWorkorder,
} from './GenerateTerm.service';
import {
  GenerateLgpdTermInterface,
  generateTermsWorkorderInterface,
} from './GenerateTerm.types';

export default function useGenerateTermLGPD(reportName: string) {
  const intl = useIntl();
  const mutation = useMutation(
    (obj: GenerateLgpdTermInterface) => generateLgpdTerm(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'customers.notification.generate.report.title',
          }),
          description: `${reportName} gerado com Sucesso!`,
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useGenerateTerm() {
  const intl = useIntl();
  const mutation = useMutation(
    (request: generateTermsWorkorderInterface) =>
      generateTermsWorkorder(request),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'customers.notification.generate.report.title',
          }),
          description: intl.formatMessage({
            id: 'customers.notification.generate.report.description',
          }),
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
